import React from 'react';
import { Button, Flex, Typography, Popconfirm } from 'antd';

import { useCreateShopAllProductsBuyableMutation } from '../../shops/service/shops';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { useAppSelector } from '../../../../../store';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';

const { Text } = Typography;

const actions = [
    {
        key: 1,
        title: 'Перевести статус всех товаров магазина в покупаемые?',
        button: 'Покупка',
    },
    {
        key: 0,
        title: 'Перевести статус всех товаров магазина "по предзаказу"?',
        button: 'По предзаказу',
    },
];

const Buyable = () => {
    const current = useAppSelector(selectShopCurrent);

    const [createBuyableAll, { data, isSuccess, isLoading, isError, error }] =
        useCreateShopAllProductsBuyableMutation();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, data?.message, null, true);

    const onClick = async (buyable: number) => {
        await createBuyableAll({ id: current.id, buyable: buyable });
    };

    return (
        <Flex vertical gap={8}>
            <Text>Перевести все товары:</Text>
            <Flex vertical={false} gap={24}>
                {actions.map(action => (
                    <Popconfirm
                        key={action.key}
                        title={action.title}
                        onConfirm={() => onClick(action.key)}
                        okText='Да'
                        cancelText='Нет'
                    >
                        <Button
                            loading={isLoading}
                            disabled={!current.payment_system || isLoading}
                        >
                            {action.button}
                        </Button>
                    </Popconfirm>
                ))}
            </Flex>
        </Flex>
    );
};

export default Buyable;
